import React from 'react';
import {Container} from 'react-bootstrap'
import logoIcon from '../../../images/logo-icon.svg'
import './header.scss'

const Header = () => {
  return (
    <header className="header">
      <Container fluid>
        <div className="header-logo">
          <span>Hubble</span>
          <img src={logoIcon} className="img-responsive" alt="logo" />
        </div>
      </Container>
    </header>
  );
};

export default Header;
